import { render, staticRenderFns } from "./SurveyPopup.vue?vue&type=template&id=d98b04d0&scoped=true&"
import script from "./SurveyPopup.vue?vue&type=script&lang=js&"
export * from "./SurveyPopup.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPopup.vue?vue&type=style&index=0&id=d98b04d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98b04d0",
  null
  
)

export default component.exports